module.exports = [ '$scope', 'ngDialog', function($scope, ngDialog){
    this.openContact = function(facilityId) {
        ngDialog.open({
            template: 'templates/popup-contact.layout.jade',
            scope: $scope,
            className: 'ngdialog-contact',
            controller: 'PopupContactController',
            data: {
                facility: this.findFacility(facilityId)
            }
        });

      (ga||angular.noop)('send', 'pageview', '/rdv');
    }; 

    this.findFacility = function(facilityId) {
        for(var i = 0, sz = $scope.facilities.length; i < sz; i++) {
            if ($scope.facilities[i].id === facilityId) {
                return $scope.facilities[i];
            }
        }

        return null;
    }

    this.navigate = function(link) {
        window.location.href = link;
    };
}];


//////////////////
// WEBPACK FOOTER
// ./assets/app/app.controller.js
// module id = 8
// module chunks = 0